import { combineReducers } from '@reduxjs/toolkit'
import RolesPermissionsReducer from './reducer'
const reducer = combineReducers({
  RolesPermissionsReducer,
})

export default reducer
